export interface StoryAvatarProps {
  imageSrcUrl?: string | null;
  brandName: string;
}

export function StoryAvatar({
  imageSrcUrl = null,
  brandName,
}: StoryAvatarProps) {
  return (
    <div className="lookbook--story--avatar">
      {imageSrcUrl?.length ? (
        <img
          src={imageSrcUrl}
          alt={brandName}
          className="lookbook--story--avatar--image"
        />
      ) : (
        <div className="lookbook--story--avatar--alt">
          {brandName.trim().length ? brandName.trim()[0] : "L"}
        </div>
      )}
    </div>
  );
}
